import { Grid } from '@mui/material';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';

import { ITimelineItem } from '@clients/timelineClient';
import TimelineDetailsBodyFactory from '@components/timelineDetails/timelineDetailsBodyFactory/TimelineDetailsBodyFactory';

interface TransactionDetailsProps {
    timelineItem: ITimelineItem;
    isLoading?: boolean;
}

const TimelineDetailsBody = ({
    timelineItem,
    isLoading,
}: TransactionDetailsProps) => {
    const { theme } = useTheme();

    return (
        <Grid
            container
            item
            flexDirection="row"
            xs={12}
            sx={{
                bgcolor: theme?.palette?.background?.paper,
                pt: 4.375,
                pl: 2.625,
                py: 4,
                px: 3,
                mb: 0.25,
            }}>
            <Grid
                container
                item
                flexDirection="column"
                xs={12}
                sx={{
                    bgcolor: theme?.palette?.background?.paper,
                    pt: 4.375,
                    pl: 2.625,
                    py: 4,
                    px: 3,
                    mb: 0.25,
                }}>
                <Grid item>
                    <TimelineDetailsBodyFactory
                        timelineItem={timelineItem}
                        isLoading={isLoading}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default TimelineDetailsBody;
